import { render, staticRenderFns } from "./valueAdditionManufacturing.vue?vue&type=template&id=6c733b66&scoped=true&"
import script from "./valueAdditionManufacturing.vue?vue&type=script&lang=js&"
export * from "./valueAdditionManufacturing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c733b66",
  null
  
)

export default component.exports